import {PlantAccess} from './PlantAccess';
import {LineBarAccessConfig} from './LineBarAccessConfig';
import {Company} from './Company';
import {UserRole} from './UserRole';
import {UserSubscriptionPreferences} from './UserSubscriptionPreferences';
import {FileMetaData} from './FileMetaData';
import {Region} from './Region';
import {UserGeographicalAssignmentTypes} from './UserGeographicalAssignmentTypes';

export class User {
  userId?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  plantAccess?: Array<PlantAccess>;
  lineBarAccess?: Array<LineBarAccessConfig>;
  company?: Company;
  userRole?: UserRole;
  languageId?: number;
  languageCode?: string;
  isSee?: boolean;
  phoneNumber?: string;
  emailPreference?: boolean;
  smsPreference?: boolean;
  title?: string;
  isTermsAndConditionsAccepted?: boolean;
  userSubscriptionPreferences?: UserSubscriptionPreferences;
  isPasswordPrivate?: boolean;
  profileImage?: FileMetaData;
  removeProfileImage?: boolean;
  geographicalAssignment?: Region;
  createdOn?: number;
  resetPasswordToken?: string;
  // dateFormat?: DateTimeF;
  // timeFormat?: DateTimeF;
  dateFormat?: any;
  timeFormat?: any;
  lastLoggedOn?: number;
  isConnected?: boolean;
  lastConnected?: number;
  isResendWelcomeEmail?: boolean;
  createdUser?: string;
  modifiedDate?: number;
  modifiedUser?: string;

  static getCompanyName(user: User) {
    if (user.company) {
      return user.company.companyName;
    }
    return '';
  }

  static getCompanyId(user: User) {
    if (user.company) {
      return user.company.companyId;
    }
    return -1;
  }

  static getName(user: User) {
    let result = '';

    if (user.firstName) {
      result = user.firstName + ' ';
    }
    if (user.lastName) {
      result += user.lastName;
    }
    if (!result) {
      result = user.email || '';
    }

    return result;
  }

  static getRoleKey(user: User) {
    return user.userRole?.keyName || '';
  }

  static getRoleLabel(user: User) {
    return user.userRole?.userRoleText || '';
  }

  static getProfileImageUrl(user: User) {
    if (user.profileImage) {
      return user.profileImage.fileURL;
    }

    return '';
  }

  static getProfileImageId(user: User) {
    if (user.profileImage) {
      return user.profileImage.fileId;
    }

    return '';
  }

  static isEmailNotificationEnabled(user: User) {
    if (user.userSubscriptionPreferences) {
      return user.userSubscriptionPreferences.isEmailNotificationSelected;
    }

    return false;
  }

  static isSmsNotificationEnabled(user: User) {
    if (user.userSubscriptionPreferences) {
      return user.userSubscriptionPreferences.isSmsNotificationSelected;
    }

    return false;
  }

  static setEmailNotificationEnabled(user: User, value: boolean) {
    if (!user.userSubscriptionPreferences) {
      user.userSubscriptionPreferences = new UserSubscriptionPreferences();
    }

    user.userSubscriptionPreferences.isEmailNotificationSelected = value;
  }

  static setSmsNotificationEnabled(user: User, value: boolean) {
    if (!user.userSubscriptionPreferences) {
      user.userSubscriptionPreferences = new UserSubscriptionPreferences();
    }

    user.userSubscriptionPreferences.isSmsNotificationSelected = value;
  }

  static setClient(user: User, clientId: number) {
    user.company = new Company();
    user.company.companyId = clientId;
  }

  static getRegionText(user: User): string {
    return user.geographicalAssignment?.regionText || '';
  }

  static getRegionAssignmentType(user: User): UserGeographicalAssignmentTypes | undefined {
    return user.geographicalAssignment?.userGeographicalAssignmentType;
  }

  static getRegionAssignment(user: User): Region | undefined {
    return user.geographicalAssignment;
  }

  static getPlantAccess(user: User) {
    if (!user.plantAccess || user.plantAccess.length === 0) {
      return [];
    }
    return user.plantAccess.map((pa) => pa.plantId);
  }

  static getLineBarAccess(user: User) {
    if (!user.lineBarAccess || user.lineBarAccess.length === 0) {
      return [];
    }
    return user.lineBarAccess.map((la) => la.lineId);
  }
}
